import Vue from 'vue'
import Router from 'vue-router'

//组件  star
import c_Head from '@/components/Head/Head'
import c_Nav from '@/components/Nav/Nav'

//留言暂时无法实现多条循环
import c_NewMessage from '@/components/NewMessage/NewMessage'

import c_HotCars from '@/components/HotCars/HotCars'
import c_CarType from '@/components/CarType/CarType'

//我们的优势
import c_OurAd from '@/components/OurAd/OurAd'

import c_ContactUs from '@/components/ContactUs/ContactUs'

//企业背景
import c_Epbg from '@/components/Epbg/Epbg'

import c_Honor from '@/components/Honor/Honor'
import c_Foot from '@/components/Foot/Foot'
import c_Banner from '@/components/Banner/Banner'
import c_LeaveMessage from '@/components/LeaveMessage/LeaveMessage'
import c_CallUp from '@/components/CallUp/CallUp'
import c_Map from '@/components/Map/Map'


//遮罩层
import c_Mask from '@/components/Mask/Mask'
//组件  end



//页面  star
import c_Index from '@/components/Index/Index'    //首页页面
import c_Second from '@/components/Second/Second'   //车型展示页面
import c_SuccessCase from '@/components/SuccessCase/SuccessCase'  //成功案列
import c_SuccessCaseDetail from '@/components/SuccessCaseDetail/SuccessCaseDetail'  //成功案列详情
import c_ScopeService from '@/components/ScopeService/ScopeService'   //服务范围
import c_FourPage from '@/components/FourPage/FourPage'   //租车须知
import c_NewsCenter from '@/components/NewsCenter/NewsCenter'  //新闻中心
import c_NewsCenterDetail from '@/components/NewsCenterDetail/NewsCenterDetail'  //新闻中心详情
import c_NavContactUs from '@/components/NavContactUs/NavContactUs'   //联系我们
//页面  end

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',      //首页
      name: 'Index',
      component: c_Index
    },
    {
      path:'/Second',  //车型展示页面
      name:'Second',
      component:c_Second
    },
    {
      path:'/SuccessCase',   //成功案列
      name:'SuccessCase',
      component:c_SuccessCase
    },
    {
      path:'/SuccessCaseDetail',  //成功案列详情
      name:'SuccessCaseDetail',
      component:c_SuccessCaseDetail
    },
    {
      path:'/ScopeService',  //服务范围
      name:'ScopeService',
      component:c_ScopeService
    },
    {
      path:'/FourPage',  //租车须知
      name:'/FourPage',
      component:c_FourPage
    },
    {
      path:'/NewsCenter',  //新闻中心
      name:'NewsCenter',
      component:c_NewsCenter
    },
    {
      path:'/NewsCenterDetail',  //新闻中心详情
      name:'NewsCenterDetail',
      component:c_NewsCenterDetail
    },
    {
      path:'/NavContactUs',  //  联系我们
      name:'NavContactUs',
      component:c_NavContactUs
    }
  ],
  mode:'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js